import { render, staticRenderFns } from "./CardLayout.vue?vue&type=template&id=6b2ecb7a&"
import script from "./CardLayout.vue?vue&type=script&lang=js&"
export * from "./CardLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\takaj\\Documents\\COFOUNDRY\\okinus-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b2ecb7a')) {
      api.createRecord('6b2ecb7a', component.options)
    } else {
      api.reload('6b2ecb7a', component.options)
    }
    module.hot.accept("./CardLayout.vue?vue&type=template&id=6b2ecb7a&", function () {
      api.rerender('6b2ecb7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/fndry-vue/packages/fn-ui/components/card-layout/CardLayout.vue"
export default component.exports